// src/api/TrackApplications.js
import { listApplications } from "./applications";

/**
 * Fetch applications by applicant's email from the backend.
 * Filters data based on the applicant email and returns the results.
 * 
 * @param {string} applicantEmail - The applicant's email to filter by.
 * @param {object} opts - Optional parameters (limit, orderBy, fields).
 * @returns {Promise<object[]>} - List of applications for the specified applicant.
 */
export async function getTrackApplicationsByApplicant(applicantEmail, opts = {}) {
  const {
    limit = 50,
    orderBy = "modified desc",
    fields = ["*"],
  } = opts;

  return listApplications({
    applicant: applicantEmail, // Helper will convert this to filter
    limit_page_length: limit,
    order_by: orderBy,
    fields: JSON.stringify(fields),
  });
}

/**
 * Optional: fetch one application by name (docname)
 */
export async function getTrackApplicationByName(name) {
  // Can import getApplication if needed, or just redirect
  const { getApplication } = require("./applications");
  return getApplication(name);
}
